export default __webpack_public_path__ + "static/ht-c82b7fb47738b38fc9f2a85e157a4227.svg";